import { render, staticRenderFns } from "./addPolicy.vue?vue&type=template&id=62c302db&scoped=true&"
import script from "./addPolicy.vue?vue&type=script&lang=js&"
export * from "./addPolicy.vue?vue&type=script&lang=js&"
import style0 from "./addPolicy.vue?vue&type=style&index=0&id=62c302db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c302db",
  null
  
)

export default component.exports